import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { Flex } from 'onefaceui-react-components';
import { v4 as uuid } from 'uuid';

import Icon from 'react/components/Icon';
import ScrollableContent from 'react/components/RouteDetails/ScrollableContent';
import { getResourceTo } from 'react/utils/utils';

const equipmentSuggestionIconUrl = require("static/images/icon-geocode-parked-equipment-suggestion.svg");
const googleSuggestionIconUrl = require("static/images/icon-geocode-google-suggestion.svg");

const getDistanceFormatted = (latLngStart, latLngEnd) => {
  const awayResource = Monet.I18n.getResourcesByKey('Greenmile.SuggestGeocodeStop.away');

  const distance = L.latLng(latLngStart).distanceTo(latLngEnd);
  let distanceFormatted = new Monet.Format.DISTANCE(distance).toGrid().getValue();
  if (distanceFormatted) {
    distanceFormatted += ' ' + awayResource;
  }
  return distanceFormatted;
};

const scrollableContentStyles = {
  base: {
    minHeight: '125px'
  },
  container: {
    minHeight: '125px'
  }
}

class Geocode extends PureComponent {

  setMarkerFocus = (lat, lng) => {
    const { routeId } = this.props;
    const screen = Monet.Session.RouteDetail.screensList[routeId];
    Greenmile.Map.Utility.setMarkerFocus(screen, { lat, lng });
  }

  renderGoogleSuggestion = (suggest, i) => {
    const { stop } = this.props;
    const stopLat = stop.get('latitude', stop.getIn(['location', 'latitude']));
    const stopLng = stop.get('longitude', stop.getIn(['location', 'longitude']));
    const resourceAddressGeocoded = Monet.I18n.getResourcesByKey('RouteDetail.GeocodeStop.addressGeocoded');
    const latLng = suggest.getIn(['geometry', 'location']);
    const latLngStart = [stopLat, stopLng];
    const latLngEnd = [latLng.lat(), latLng.lng()];
    const textAddressGeocoded = `${resourceAddressGeocoded}, ${getDistanceFormatted(latLngStart, latLngEnd)}`;
    const onClickFunc = () => {
      this.setMarkerFocus(latLng.lat(), latLng.lng());
    }
    return (
      <Flex
        key={uuid()}
        alignItems="center"
        justifyContent="space-between"
        className="geocode-item"
        onClick={onClickFunc}
      >
        <div>{textAddressGeocoded}</div>
        <div><Icon iconUrl={googleSuggestionIconUrl}/></div>
      </Flex>
    );
  }

  renderEquipmentSuggestions = (suggest, i) => {
    const { stop } = this.props;
    const stopLat = stop.get('latitude', stop.getIn(['location', 'latitude']));
    const stopLng = stop.get('longitude', stop.getIn(['location', 'longitude']));
    const suggestLat = suggest.getIn(['position', 'latitude']);
    const suggestLng = suggest.getIn(['position', 'longitude']);
    const timeToArrival = Monet.Format.Time.formatToLocale(suggest.get('date'));
    const timeDeparture = Monet.Format.Time.formatToLocale(suggest.get('nextCoordinateDate'));
    const elapsedTime = new Monet.Format.MILLISECONDS(suggest.get('diffTime')).formatToElapsedTime().getValue();
    const latLngStart = [stopLat, stopLng];
    const latLngEnd = [suggestLat, suggestLng];
    const textEquipmentParked = `${timeToArrival} - ${timeDeparture}, ${elapsedTime} ${getDistanceFormatted(latLngStart, latLngEnd)}`;
    const onClickFunc = () => {
      this.setMarkerFocus(suggestLat, suggestLng);
    }

    return (
      <Flex
        key={uuid()}
        alignItems="center"
        justifyContent="space-between"
        className="geocode-item"
        onClick={onClickFunc}
      >
        <div>{textEquipmentParked}</div>
        <div><Icon iconUrl={equipmentSuggestionIconUrl}/></div>
      </Flex>
    );
  };

  render () {
    const { googleSuggestions, equipmentSuggestions } = this.props;
    const gSuggestions = googleSuggestions.map((suggest, i) => this.renderGoogleSuggestion(suggest, i)).toArray();
    const equipSuggestions = equipmentSuggestions.map((suggest, i) => this.renderEquipmentSuggestions(suggest, i)).toArray();
    const hasGoogleSuggestions = gSuggestions.length > 0;
    const hasEquipmentSuggestions = equipSuggestions.length > 0;

    return (
      <ScrollableContent styles={scrollableContentStyles}>
        <Flex
          alignItems="center"
          className="geocode-title"
        >
          <div>{getResourceTo('Greenmile.SuggestGeocodeStop.googleSuggestions')}</div>
        </Flex>
        {hasGoogleSuggestions ? gSuggestions : (
          <Flex
            alignItems="center"
            className="geocode-item"
          >
            <div>{getResourceTo('Greenmile.SuggestGeocodeStop.noSuggestions')}</div>
          </Flex>
        )}
        <Flex
          alignItems="center"
          className="geocode-title"
        >
          <div>{getResourceTo('Greenmile.SuggestGeocodeStop.suggestByEquipmentStopped')}</div>
        </Flex>
        {hasEquipmentSuggestions ? equipSuggestions : (
          <Flex
            alignItems="center"
            className="geocode-item"
          >
            <div>{getResourceTo('Greenmile.SuggestGeocodeStop.noSuggestions')}</div>
          </Flex>
        )}
      </ScrollableContent>
    );
  }
}

Geocode.propTypes = {
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  routeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number ]).isRequired,
  stop: PropTypes.object.isRequired,
  googleSuggestions: PropTypes.object.isRequired,
  equipmentSuggestions: PropTypes.object.isRequired
}

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({
  googleSuggestions: stopDetailsPopup.getIn(['geocode', String(routeId), String(stopId), 'googleSuggestions'], Map([])),
  equipmentSuggestions: stopDetailsPopup.getIn(['geocode', String(routeId), String(stopId), 'equipmentSuggestions'], Map([]))
});

export default connect(mapStateToProps, null)(Geocode);
